if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.dialog = this.querySelector('.product-media-modal__dialog');
        this.content = this.querySelector('.product-media-modal__content');
        this.previousButton = this.querySelector('[data-lightbox-previous]');
        this.nextButton = this.querySelector('[data-lightbox-next]');
        this.currentCounter = this.querySelector('[data-lightbox-current]');
        this.totalCounter = this.querySelector('[data-lightbox-total]');
        this.activeIndex = 0;
        this.touchStart = null;

        this.boundKeydown = this.onKeydown.bind(this);
        this.previousButton?.addEventListener('click', () => this.showRelativeMedia(-1));
        this.nextButton?.addEventListener('click', () => this.showRelativeMedia(1));

        this.dialog?.addEventListener('pointerup', (event) => {
          if (event.target !== this.dialog) event.stopPropagation();
        });

        this.content?.addEventListener(
          'touchstart',
          (event) => {
            const touch = event.changedTouches[0];
            this.touchStart = { x: touch.clientX, y: touch.clientY };
          },
          { passive: true }
        );

        this.content?.addEventListener(
          'touchend',
          (event) => {
            if (!this.touchStart) return;
            const touch = event.changedTouches[0];
            const deltaX = touch.clientX - this.touchStart.x;
            const deltaY = touch.clientY - this.touchStart.y;
            this.touchStart = null;

            if (Math.abs(deltaX) < 50 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
            this.showRelativeMedia(deltaX < 0 ? 1 : -1);
          },
          { passive: true }
        );
      }

      get mediaItems() {
        return Array.from(this.content?.children || []).filter((item) => item.hasAttribute('data-media-id'));
      }

      show(opener) {
        super.show(opener);
        this.showMediaById(opener.getAttribute('data-media-id'));
        document.addEventListener('keydown', this.boundKeydown);
      }

      hide() {
        document.removeEventListener('keydown', this.boundKeydown);
        super.hide();
      }

      showMediaById(mediaId) {
        const items = this.mediaItems;
        if (!items.length) return;

        const requestedIndex = items.findIndex((item) => String(item.dataset.mediaId) === String(mediaId));
        this.showMediaAt(requestedIndex >= 0 ? requestedIndex : 0);
      }

      showMediaAt(index) {
        const items = this.mediaItems;
        if (!items.length) return;

        this.activeIndex = (index + items.length) % items.length;
        items.forEach((item, itemIndex) => {
          const isActive = itemIndex === this.activeIndex;
          item.classList.toggle('active', isActive);
          item.setAttribute('aria-hidden', String(!isActive));
        });

        const activeMedia = items[this.activeIndex];
        const template = activeMedia.querySelector('template');
        const templateContent = template ? template.content : null;

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          templateContent &&
          templateContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }

        this.updateControls(items.length);
      }

      showRelativeMedia(direction) {
        window.pauseAllMedia();
        this.showMediaAt(this.activeIndex + direction);
      }

      updateControls(total) {
        if (this.currentCounter) this.currentCounter.textContent = String(this.activeIndex + 1);
        if (this.totalCounter) this.totalCounter.textContent = String(total);

        const hasMultipleItems = total > 1;
        [this.previousButton, this.nextButton].forEach((button) => {
          if (!button) return;
          button.hidden = !hasMultipleItems;
          button.disabled = !hasMultipleItems;
        });
      }

      onKeydown(event) {
        if (!this.hasAttribute('open')) return;
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.showRelativeMedia(-1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.showRelativeMedia(1);
        }
      }
    }
  );
}
